import React, { FC } from "react";
import Button from "components/Elements/Button/Button";
import { useContent } from "contexts/contentContext/contentContext";
import { useModal } from "contexts/modalContext/modalContext";

type RemoveMailFilesT = {
  confirm: () => void;
};

const RemoveMailFiles: FC<RemoveMailFilesT> = ({ confirm }) => {
  const { getTextByKey, getHtmlByKey } = useContent();
  const { closeModal } = useModal();

  const handleRemove = () => {
    confirm?.();
    closeModal();
  };

  return (
    <div className="remove-files-wrapper">
      <h1>{getTextByKey("delete-files-title")}</h1>
      <p>{getHtmlByKey("delete-files-description")}</p>
      <div className="buttons">
        <Button gray onClick={closeModal}>
          {getTextByKey("cancel")}
        </Button>
        <Button onClick={handleRemove}>{getTextByKey("remove")}</Button>
      </div>
    </div>
  );
};

export default RemoveMailFiles;
